import React from "react";
import * as S from "./index.styles";
import { StreetInputFieldProps } from "./LocationFields.types";

const StreetInputField: React.FC<StreetInputFieldProps> = ({
  value, onChange, label, required, border
}) => (
  <S.FieldContainer>
    <S.FieldTitle>
      {label}
      {required && <S.RequiredAsterisk> *</S.RequiredAsterisk>}
    </S.FieldTitle>
    <S.LocationInput
      type="text"
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      placeholder={`Enter ${label}`}
    />
  </S.FieldContainer>
);

export default StreetInputField; 